import { toast } from 'react-toastify';
import api from '../config/ApiConfig';

// Cache simple pour éviter trop d'appels API
const cache = {
  orders: null,
  ordersTimestamp: null,
  CACHE_DURATION: 120000, // 2 minutes (augmenté pour éviter les erreurs 429)
};

export const orderService = {
  // Envoyer la demande de commande
  async addDemandeCommandeFournisseur(data, history) {
    try {
      if (data instanceof FormData) {
        console.log("📦 Contenu FormData :");
        for (let [key, value] of data.entries()) {
          console.log(`${key}:`, value);
        }
      } else {
        console.log("Payload JSON :", JSON.stringify(data, null, 2));
      }

      const response = await api.post('/fo/sendMailDemandeCommandeFournisseur', data);

      toast.success('Commande enregistrée avec succès!', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        onClose: () => {
          history.push("/confirmation");
        },
      });

      return response.data;
    } catch (error) {
      console.error('Error fetching', error);
      toast.error('Échec. Veuillez réessayer.', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      throw error;
    }
  },

  // Analyse du bordereau PDF pour extraire le poids
  async parseBordereau(file) {
    try {
      const fd = new FormData();
      fd.append('bordereau', file);

      console.log('📄 Envoi du bordereau pour analyse OCR...');
      console.log('Fichier:', file.name, 'Type:', file.type, 'Taille:', file.size, 'bytes');

      const { data } = await api.post('/bo/ocr-bordereau', fd, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      console.log('✅ Analyse OCR terminée:', data);
      return data; // { ok: boolean, poids_total_kg?: number, bucket?: string }
    } catch (error) {
      console.error('❌ Erreur lors de l\'analyse OCR:', error);
      console.error('Status:', error.response?.status);
      console.error('Données complètes de l\'erreur:', JSON.stringify(error.response?.data, null, 2));
      console.error('Erreurs de validation:', error.response?.data?.errors);
      console.error('Message d\'erreur:', error.response?.data?.message || error.message);

      // Ne pas bloquer l'utilisateur si l'OCR échoue
      return { ok: false, error: error.response?.data?.message || 'Erreur lors de l\'analyse du bordereau' };
    }
  },

  // Récupérer la dernière commande
  async getLastDelivery(idFournisseur) {
    const response = await api.get(`/fo/last-delivery/${idFournisseur}`);
    return response.data;
  },

  // Récupérer l'historique des commandes (avec cache)
  async getOrderHistory(forceRefresh = false) {
    const now = Date.now();

    // Utiliser le cache si disponible et non expiré
    if (
      !forceRefresh &&
      cache.orders &&
      cache.ordersTimestamp &&
      (now - cache.ordersTimestamp) < cache.CACHE_DURATION
    ) {
      console.log('📦 Utilisation du cache pour les commandes');
      return cache.orders;
    }

    // Sinon, faire l'appel API
    console.log('🌐 Récupération des commandes depuis l\'API');
    const response = await api.get('/fo/my-orders');

    // Mettre en cache le résultat
    cache.orders = response.data;
    cache.ordersTimestamp = now;

    return response.data;
  },

  // Fonction pour invalider le cache (utile après une nouvelle commande)
  clearOrdersCache() {
    cache.orders = null;
    cache.ordersTimestamp = null;
  },

  // Récupérer les images POD (Proof of Delivery) pour une commande
  async getPodImages(commandeId) {
    try {
      const response = await api.get(`/fo/commande/${commandeId}/pod-images`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des images POD:', error);
      throw error;
    }
  },

  // Récupérer les données de tracking en temps réel (endpoint public)
  async getTrackingData(trackingToken) {
    try {
      const response = await api.get(`/track/${trackingToken}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données de tracking:', error);
      throw error;
    }
  },
};
